(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["en-five-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('en-five-hero-video')) return;
  class EnFiveHeroVideo extends HTMLElement {
    connectedCallback() {
      if (this.events && !this.events.signal.aborted) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('.en-five-hero__video-toggle');
      this.label = this.querySelector('.en-five-hero__video-label');
      if (!this.video || !this.button) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.intent = 'auto';
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.tabIndex = -1;
      this.inViewport = this.intersectsViewport();
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        this.intent = this.video.paused || this.video.ended ? 'play' : 'pause';
        this.updatePlayback();
      }, options);
      this.video.addEventListener('play', () => this.syncControl(), options);
      this.video.addEventListener('pause', () => this.syncControl(), options);
      this.video.addEventListener('loadedmetadata', () => this.updatePlayback(), options);
      this.video.addEventListener('error', () => {
        this.video.pause();
        this.dataset.videoState = 'error';
        this.button.hidden = true;
      }, options);
      this.motion.addEventListener('change', () => this.updatePlayback(), options);
      document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inViewport = entries[0].isIntersecting && entries[0].intersectionRatio > 0;
          this.updatePlayback();
        }, { threshold: 0 });
        this.observer.observe(this);
      } else {
        const updateVisibility = () => {
          this.inViewport = this.intersectsViewport();
          this.updatePlayback();
        };
        window.addEventListener('scroll', updateVisibility, { ...options, passive: true });
        window.addEventListener('resize', updateVisibility, options);
      }
      this.syncControl();
      this.updatePlayback();
    }
    intersectsViewport() {
      const r = this.getBoundingClientRect();
      return r.height > 0 && r.width > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth;
    }
    updatePlayback() {
      if (!this.isConnected || !this.video) return;
      const wantsPlayback = this.intent === 'play' || this.intent === 'auto' && !this.motion.matches;
      if (this.inViewport && !document.hidden && wantsPlayback && !this.video.error) {
        if (this.video.paused) this.video.play().catch(() => {
          if (this.isConnected) this.syncControl();
        });
      } else {
        this.video.pause();
      }
      this.syncControl();
    }
    syncControl() {
      if (this.video.error) {
        this.dataset.videoState = 'error';
        this.button.hidden = true;
        return;
      }
      const playing = !this.video.paused && !this.video.ended;
      const text = playing ? this.button.dataset.labelPause : this.button.dataset.labelPlay;
      this.dataset.videoState = playing ? 'playing' : 'paused';
      this.button.setAttribute('aria-label', text);
      this.label.textContent = text;
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
  }
  customElements.define('en-five-hero-video', EnFiveHeroVideo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
